module.exports = __webpack_public_path__ + "static/img/book12.7800948.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book12.jpg
// module id = jGPi
// module chunks = 1